import React from 'react';

const CommonPopupForm = ({ title, onSubmit, isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-5xl h-fit shadow-lg flex flex-col">
        <h2 className="text-2xl font-semibold text-[#019c89] mb-4">{title}</h2>
        <form onSubmit={onSubmit} className="flex flex-col justify-between flex-1 gap-5">
          {/* Make only this container scrollable */}
          <div className="overflow-y-auto pr-2 space-y-6 flex-1">
            {children}
          </div>

          {/* Action buttons */}
          <div className="flex justify-end space-x-2 pt-6 border-t mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded bg-gray-300 text-black hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded bg-[#019c89] text-white hover:bg-[#017a6e]"
            >
              Submit
            </button>
          </div>
        </form>


      </div>
    </div>

  );
};

export default CommonPopupForm;
